{
  "{{ commaSeparatedUsers }} and {{ moreCount }} more": "{{ commaSeparatedUsers }} e altri {{ moreCount }}",
  "{{ commaSeparatedUsers }}, and {{ lastUser }}": "{{ commaSeparatedUsers }} e {{ lastUser }}",
  "{{ count }} files_one": "{{ count }} file",
  "{{ count }} files_many": "{{ count }} file",
  "{{ count }} files_other": "{{ count }} file",
  "{{ count }} people are typing_one": "{{ count }} persona sta scrivendo",
  "{{ count }} people are typing_many": "{{ count }} persone stanno scrivendo",
  "{{ count }} people are typing_other": "{{ count }} persone stanno scrivendo",
  "{{ count }} photos_one": "{{ count }} foto",
  "{{ count }} photos_many": "{{ count }} foto",
  "{{ count }} photos_other": "{{ count }} foto",
  "{{ count }} reactions_one": "{{ count }} reazione",
  "{{ count }} reactions_many": "{{ count }} reazioni",
  "{{ count }} reactions_other": "{{ count }} reazioni",
  "{{ count }} videos_one": "{{ count }} video",
  "{{ count }} videos_many": "{{ count }} video",
  "{{ count }} videos_other": "{{ count }} video",
  "{{ firstUser }} and {{ secondUser }}": "{{ firstUser }} e {{ secondUser }}",
  "{{ imageCount }} more": "+ {{ imageCount }}",
  "{{ memberCount }} members": "{{ memberCount }} membri",
  "{{ typing }} are typing": "{{ typing }} stanno scrivendo",
  "{{ typing }} is typing": "{{ typing }} sta scrivendo",
  "{{ user }} has been muted": "{{ user }} è stato silenziato",
  "{{ user }} has been unmuted": "Notifiche riattivate per {{ user }}",
  "{{ user }} is typing...": "{{ user }} sta digitando...",
  "{{ users }} and {{ user }} are typing...": "{{ users }} e {{ user }} stanno digitando...",
  "{{ users }} and more are typing...": "{{ users }} e altri stanno digitando...",
  "{{ watcherCount }} online": "{{ watcherCount }} online",
  "{{count}} new messages_one": "{{count}} nuovo messaggio",
  "{{count}} new messages_many": "{{count}} nuovi messaggi",
  "{{count}} new messages_other": "{{count}} nuovi messaggi",
  "{{count}} unread_one": "{{count}} non letto",
  "{{count}} unread_many": "{{count}} non letti",
  "{{count}} unread_other": "{{count}} non letti",
  "{{count}} votes_one": "{{count}} voto",
  "{{count}} votes_many": "{{count}} voti",
  "{{count}} votes_other": "{{count}} voti",
  "+{{ imageCount }}": "+{{ imageCount }}",
  "+{{count}} more options_one": "+{{count}} altra opzione",
  "+{{count}} more options_many": "+{{count}} altre opzioni",
  "+{{count}} more options_other": "+{{count}} altre opzioni",
  "🏙 Attachment...": "🏙 Allegato...",
  "📊 {{createdBy}} created: {{ pollName}}": "📊 {{createdBy}} ha creato: {{ pollName}}",
  "📊 {{votedBy}} voted: {{pollOptionText}}": "📊 {{votedBy}} ha votato: {{pollOptionText}}",
  "📍Shared location": "📍Posizione condivisa",
  "Add a comment": "Aggiungi un commento",
  "Add a comment to your poll answer": "Aggiungi un commento alla tua risposta al sondaggio",
  "Add an option": "Aggiungi un'opzione",
  "Add reaction": "Aggiungi reazione",
  "All results loaded": "Tutti i risultati caricati",
  "Allow access to camera": "Consenti l'accesso alla fotocamera",
  "Allow access to microphone": "Consenti l'accesso al microfono",
  "Allow comments": "Consenti i commenti",
  "Allow option suggestion": "Consenti il suggerimento di opzioni",
  "Allow others to add comments": "Consenti ad altri di aggiungere commenti",
  "Also send as a direct message": "Invia anche come messaggio diretto",
  "Also send in channel": "Invia anche nel canale",
  "Also sent in channel": "Inviato anche nel canale",
  "An error has occurred during recording": "Si è verificato un errore durante la registrazione",
  "An error has occurred during the recording processing": "Si è verificato un errore durante l'elaborazione della registrazione",
  "Anonymous": "Anonimo",
  "Anonymous poll": "Sondaggio anonimo",
  "Archive": "Archivia",
  "Are you sure you want to delete this message?": "Sei sicuro di voler eliminare questo messaggio?",
  "aria/Attachment": "Allegato",
  "aria/Attachment Actions": "Azioni allegato",
  "aria/Audio position {{ elapsed }} of {{ duration }}": "Posizione audio {{ elapsed }} di {{ duration }}",
  "aria/Audio position {{ progress }} percent": "Posizione audio {{ progress }} percento",
  "aria/Block User": "Blocca utente",
  "aria/Bookmark Message": "Salva messaggio",
  "aria/Cancel recording": "Annulla registrazione",
  "aria/Cancel Reply": "Annulla risposta",
  "aria/Cancel upload": "Annulla caricamento",
  "aria/Channel Actions": "Azioni canale",
  "aria/Channel list": "Elenco dei canali",
  "aria/Channel search results": "Risultati della ricerca dei canali",
  "aria/Chat view tabs": "Schede visualizzazione chat",
  "aria/Clear search": "Cancella ricerca",
  "aria/Close callout dialog": "Chiudi finestra informativa",
  "aria/Close thread": "Chiudi discussione",
  "aria/Collapse sidebar": "Comprimi barra laterale",
  "aria/Command Suggestions": "Suggerimenti comandi",
  "aria/Complete recording": "Completa registrazione",
  "aria/Copy Message Text": "Copia testo messaggio",
  "aria/Decrease value": "Diminuisci valore",
  "aria/Delete Message": "Elimina messaggio",
  "aria/Dismiss notification": "Chiudi notifica",
  "aria/Download attachment": "Scarica l'allegato",
  "aria/Edit Message": "Modifica messaggio",
  "aria/Emoji picker": "Selettore di emoji",
  "aria/Emoji Suggestions": "Suggerimenti emoji",
  "aria/Exit search": "Esci dalla ricerca",
  "aria/Expand sidebar": "Espandi barra laterale",
  "aria/File input": "Input di file",
  "aria/File upload": "Caricamento di file",
  "aria/Flag Message": "Segnala messaggio",
  "aria/Image failed to load": "Caricamento immagine non riuscito",
  "aria/Image input": "Input di immagine",
  "aria/Increase value": "Aumenta valore",
  "aria/Jump to latest message": "Vai all'ultimo messaggio",
  "aria/Jump to quoted message": "Vai al messaggio citato",
  "aria/Load More Channels": "Carica altri canali",
  "aria/Mark Message Unread": "Contrassegna come non letto",
  "aria/Mark messages as read": "Segna i messaggi come letti",
  "aria/Menu": "Menu",
  "aria/Message Actions": "Azioni del messaggio",
  "aria/Message from {{ user }},": "Messaggio di {{ user }},",
  "aria/Message Options": "Opzioni di messaggio",
  "aria/Message,": "Messaggio,",
  "aria/Mute User": "Mute utente",
  "aria/Notifications": "Notifiche",
  "aria/Open Attachment Selector": "Apri selettore allegati",
  "aria/Open Channel Actions Menu": "Apri menu azioni canale",
  "aria/Open Menu": "Apri menu",
  "aria/Open Message Actions Menu": "Apri il menu delle azioni di messaggio",
  "aria/Open Reaction Selector": "Apri il selettore di reazione",
  "aria/Open Thread": "Apri discussione",
  "aria/Pause": "Pausa",
  "aria/Pause recording": "Metti in pausa registrazione",
  "aria/Percent complete": "{{percent}} percento completato",
  "aria/Pin Message": "Appunta messaggio",
  "aria/Play": "Riproduci",
  "aria/Quote Message": "Citazione messaggio",
  "aria/Reaction list": "Elenco delle reazioni",
  "aria/Remind Me Message": "Ricordami",
  "aria/Remind Me Options": "Opzioni promemoria",
  "aria/Remove attachment": "Rimuovi allegato",
  "aria/Remove location attachment": "Rimuovi allegato posizione",
  "aria/Remove option": "Rimuovi opzione",
  "aria/Remove Reminder": "Rimuovi promemoria",
  "aria/Remove Save For Later": "Rimuovi Salva per dopo",
  "aria/Resend Message": "Invia di nuovo messaggio",
  "aria/Resume recording": "Riprendi registrazione",
  "aria/Retry upload": "Riprova caricamento",
  "aria/Review bounced message": "Rivedi il messaggio respinto",
  "aria/Search results": "Risultati della ricerca",
  "aria/Search results header filter button for: {{ source }}": "Pulsante filtro intestazione risultati di ricerca per: {{ source }}",
  "aria/Seek audio position": "Cerca posizione audio",
  "aria/Select Channel: {{ channelName }}": "Seleziona canale: {{ channelName }}",
  "aria/Select Reaction: {{ reactionName }}": "Seleziona reazione: {{ reactionName }}",
  "aria/Select User Channel: {{ name }}": "Seleziona canale utente: {{ name }}",
  "aria/Send": "Invia",
  "aria/Show preview": "Mostra anteprima",
  "aria/Start recording audio": "Avvia registrazione audio",
  "aria/Stop AI Generation": "Interrompi generazione IA",
  "aria/Suggestions": "Suggerimenti",
  "aria/Thread list": "Elenco thread",
  "aria/Unblock User": "Sblocca utente",
  "aria/Unmute User": "Riattiva il notifiche",
  "aria/Unpin Message": "Rimuovi messaggio appuntato",
  "aria/User Suggestions": "Suggerimenti utenti",
  "Ask a question": "Fai una domanda",
  "Attach": "Allega",
  "Attach files": "Allega file",
  "Attachment": "Allegato",
  "Attachment upload blocked due to {{reason}}": "Caricamento allegato bloccato a causa di {{reason}}",
  "Attachment upload failed due to {{reason}}": "Caricamento allegato fallito a causa di {{reason}}",
  "Back": "Indietro",
  "ban-command-args": "[@nomeutente] [testo]",
  "ban-command-description": "Vietare un utente",
  "Block User": "Blocca utente",
  "Cancel": "Annulla",
  "Cannot seek in the recording": "Impossibile cercare nella registrazione",
  "Channel archived": "Canale archiviato",
  "Channel Missing": "Il canale non esiste",
  "Channel muted": "Canale silenziato",
  "Channel pinned": "Canale fissato",
  "Channel unarchived": "Archiviazione del canale annullata",
  "Channel unmuted": "Canale non più silenziato",
  "Channel unpinned": "Canale rimosso dai fissati",
  "Channels": "Canali",
  "Chats": "Chat",
  "Choose between 2 to 10 options": "Scegli tra 2 e 10 opzioni",
  "Close": "Chiudi",
  "Close dialog": "Chiudi finestra di dialogo",
  "Close emoji picker": "Chiudi il selettore di emoji",
  "Close prompt: {{ title }}": "Chiudi prompt: {{ title }}",
  "Command not available while editing": "Comando non disponibile durante la modifica",
  "Command not available while replying": "Comando non disponibile durante la risposta",
  "Commands": "Comandi",
  "Commands matching": "Comandi corrispondenti",
  "Connection failure, reconnecting now...": "Errore di connessione, riconnessione in corso...",
  "Copy Message": "Copia messaggio",
  "Create": "Crea",
  "Create a question, add options, and configure poll settings": "Crea una domanda, aggiungi opzioni e configura le impostazioni del sondaggio",
  "Create poll": "Crea sondaggio",
  "Current location": "Posizione attuale",
  "Delete": "Elimina",
  "Delete for me": "Elimina per me",
  "Delete message": "Elimina messaggio",
  "Delivered": "Consegnato",
  "Direct message": "Messaggio diretto",
  "Do you want to end this poll now? Nobody will be able to vote in this poll anymore.": "Vuoi terminare questo sondaggio ora? Nessuno potrà più votare in questo sondaggio.",
  "Download All": "Scarica tutto",
  "Download Attachment": "Scarica allegato",
  "Download attachment {{ name }}": "Scarica l'allegato {{ name }}",
  "Drag your files here": "Trascina i tuoi file qui",
  "Drag your files here to add to your post": "Trascina i tuoi file qui per aggiungerli al tuo post",
  "Due {{ timeLeft }}": "Scadenza tra {{ timeLeft }}",
  "Due since {{ dueSince }}": "Scaduto dal {{ dueSince }}",
  "duration/Message reminder": "{{ milliseconds | durationFormatter(withSuffix: true) }}",
  "duration/Remind Me": "{{ milliseconds | durationFormatter(withSuffix: true) }}",
  "duration/Share Location": "{{ milliseconds | durationFormatter }}",
  "Edit Message": "Modifica messaggio",
  "Edit message request failed": "Richiesta di modifica del messaggio non riuscita",
  "Edited": "Modificato",
  "Emoji matching": "Abbinamento emoji",
  "Empty message...": "Messaggio vuoto...",
  "End": "Fine",
  "End poll": "Termina sondaggio",
  "End this poll?": "Terminare questo sondaggio?",
  "End vote": "Termina il voto",
  "Enforce unique vote is enabled": "Il voto unico è abilitato",
  "Error": "Errore",
  "Error adding flag": "Errore durante l'aggiunta del flag",
  "Error connecting to chat, refresh the page to try again.": "Errore di connessione alla chat, aggiorna la pagina per riprovare.",
  "Error deleting message": "Errore durante l'eliminazione del messaggio",
  "Error fetching reactions": "Errore nel caricamento delle reazioni",
  "Error marking message unread. Cannot mark unread messages older than the newest 100 channel messages.": "Errore durante la marcatura del messaggio come non letto. Impossibile marcare messaggi non letti più vecchi dei più recenti 100 messaggi del canale.",
  "Error muting a user ...": "Errore nel silenziare un utente ...",
  "Error pinning message": "Errore durante il blocco del messaggio",
  "Error removing message pin": "Errore durante la rimozione del PIN del messaggio",
  "Error reproducing the recording": "Errore durante la riproduzione della registrazione",
  "Error starting recording": "Errore durante l'avvio della registrazione",
  "Error unmuting a user ...": "Errore nel riattivare un utente ...",
  "Error uploading attachment": "Errore durante il caricamento dell'allegato",
  "Error uploading file": "Errore durante il caricamento del file",
  "Error uploading image": "Errore durante il caricamento dell'immagine",
  "Error: {{ errorMessage }}": "Errore: {{ errorMessage }}",
  "Exit command {{ command }}": "Esci dal comando {{ command }}",
  "Failed to block user": "Impossibile bloccare l'utente",
  "Failed to create the poll": "Impossibile creare il sondaggio",
  "Failed to create the poll due to {{reason}}": "Impossibile creare il sondaggio a causa di {{reason}}",
  "Failed to delete the message": "Impossibile eliminare il messaggio",
  "Failed to end the poll": "Impossibile terminare il sondaggio",
  "Failed to end the poll due to {{reason}}": "Impossibile terminare il sondaggio a causa di {{reason}}",
  "Failed to jump to the first unread message": "Impossibile passare al primo messaggio non letto",
  "Failed to leave channel": "Impossibile lasciare il canale",
  "Failed to load channels": "Impossibile caricare i canali",
  "Failed to load more channels": "Impossibile caricare altri canali",
  "Failed to mark channel as read": "Impossibile contrassegnare il canale come letto",
  "Failed to play the recording": "Impossibile riprodurre la registrazione",
  "Failed to retrieve location": "Impossibile recuperare la posizione",
  "Failed to share location": "Impossibile condividere la posizione",
  "Failed to update channel archive status": "Impossibile aggiornare lo stato di archiviazione del canale",
  "Failed to update channel mute status": "Impossibile aggiornare lo stato di silenziamento del canale",
  "Failed to update channel pinned status": "Impossibile aggiornare lo stato di blocco del canale",
  "File": "File",
  "File is required for upload attachment": "È richiesto un file per caricare l'allegato",
  "File is too large: {{ size }}, maximum upload size is {{ limit }}": "Il file è troppo grande: {{ size }}, la dimensione massima di caricamento è {{ limit }}",
  "File too large": "File troppo grande",
  "fileCount_one": "1 file",
  "fileCount_many": "{{ count }} file",
  "fileCount_other": "{{ count }} file",
  "Flag": "Segnala",
  "Generating...": "Generando...",
  "giphy-command-args": "[testo]",
  "giphy-command-description": "Pubblica un gif casuale sul canale",
  "Hide who voted": "Nascondi chi ha votato",
  "Image": "Immagine",
  "imageCount_one": "Immagine",
  "imageCount_many": "{{ count }} immagini",
  "imageCount_other": "{{ count }} immagini",
  "Instant commands": "Comandi istantanei",
  "language/af": "Afrikaans",
  "language/am": "Amarico",
  "language/ar": "Arabo",
  "language/az": "Azero",
  "language/bg": "Bulgaro",
  "language/bn": "Bengalese",
  "language/bs": "Bosniaco",
  "language/cs": "Ceco",
  "language/da": "Danese",
  "language/de": "Tedesco",
  "language/el": "Greco",
  "language/en": "Inglese",
  "language/es": "Spagnolo",
  "language/es-MX": "Spagnolo (Messico)",
  "language/et": "Estone",
  "language/fa": "Persiano",
  "language/fa-AF": "Dari",
  "language/fi": "Finlandese",
  "language/fr": "Francese",
  "language/fr-CA": "Francese (Canada)",
  "language/ha": "Hausa",
  "language/he": "Ebraico",
  "language/hi": "Hindi",
  "language/hr": "Croato",
  "language/ht": "Creolo haitiano",
  "language/hu": "Ungherese",
  "language/id": "Indonesiano",
  "language/it": "Italiano",
  "language/ja": "Giapponese",
  "language/ka": "Georgiano",
  "language/ko": "Coreano",
  "language/lt": "Lituano",
  "language/lv": "Lettone",
  "language/ms": "Malese",
  "language/nl": "Olandese",
  "language/no": "Norvegese",
  "language/pl": "Polacco",
  "language/ps": "Pashto",
  "language/pt": "Portoghese",
  "language/ro": "Rumeno",
  "language/ru": "Russo",
  "language/sk": "Slovacco",
  "language/sl": "Sloveno",
  "language/so": "Somalo",
  "language/sq": "Albanese",
  "language/sr": "Serbo",
  "language/sv": "Svedese",
  "language/sw": "Swahili",
  "language/ta": "Tamil",
  "language/th": "Thai",
  "language/tl": "Tagalog",
  "language/tr": "Turco",
  "language/uk": "Ucraino",
  "language/ur": "Urdu",
  "language/vi": "Vietnamita",
  "language/zh": "Cinese (semplificato)",
  "language/zh-TW": "Cinese (tradizionale)",
  "Leave Channel": "Lascia il canale",
  "Left channel": "Canale lasciato",
  "Let others add options": "Lascia che altri aggiungano opzioni",
  "Limit votes per person": "Limita i voti per persona",
  "Link": "Collegamento",
  "linkCount_one": "Link",
  "linkCount_many": "{{ count }} link",
  "linkCount_other": "{{ count }} link",
  "live": "live",
  "Live for {{duration}}": "Live per {{duration}}",
  "Live location": "Posizione live",
  "Live until {{ timestamp }}": "Live fino a {{ timestamp }}",
  "Load more": "Carica di più",
  "Local upload attachment missing local id": "Allegato di caricamento locale senza id locale",
  "Location": "Posizione",
  "Location sharing ended": "Condivisione posizione terminata",
  "Location: {{ coordinates }}": "Posizione: {{ coordinates }}",
  "Mark as unread": "Contrassegna come non letto",
  "Maximum number of votes (from 2 to 10)": "Numero massimo di voti (da 2 a 10)",
  "Maximum votes per person": "Voti massimi per persona",
  "Menu": "Menù",
  "Message deleted": "Messaggio cancellato",
  "Message failed to send": "Invio del messaggio non riuscito",
  "Message has been successfully flagged": "Il messaggio è stato segnalato con successo",
  "Message marked as unread": "Messaggio contrassegnato come non letto",
  "Message pinned": "Messaggio bloccato",
  "Message unpinned": "Messaggio rimosso dai fissati",
  "Message was blocked by moderation policies": "Il messaggio è stato bloccato dalle politiche di moderazione",
  "Messages have been marked unread.": "I messaggi sono stati contrassegnati come non letti.",
  "Missing permissions to upload the attachment": "Autorizzazioni mancanti per caricare l'allegato",
  "Multiple votes": "Voti multipli",
  "Mute": "Silenzia",
  "mute-command-args": "[@nomeutente]",
  "mute-command-description": "Silenzia un utente",
  "network error": "errore di rete",
  "New": "Nuovo",
  "New message from {{user}}": "Nuovo messaggio da {{user}}",
  "New Messages!": "Nuovi messaggi!",
  "Next image": "Immagine successiva",
  "No chats here yet…": "Non ci sono ancora messaggi qui...",
  "No conversations yet": "Ancora nessuna conversazione",
  "No items exist": "Nessun elemento presente",
  "No results found": "Nessun risultato trovato",
  "Nobody will be able to vote in this poll anymore.": "Nessuno potrà più votare in questo sondaggio.",
  "Nothing yet...": "Ancora niente...",
  "Offline": "Offline",
  "Ok": "OK",
  "Online": "Online",
  "Only numbers are allowed": "Sono consentiti solo numeri",
  "Only visible to you": "Visibile solo per te",
  "Open emoji picker": "Apri il selettore di emoji",
  "Open gallery at image {{ index }}": "Apri la galleria all'immagine {{ index }}",
  "Open image in gallery": "Apri immagine nella galleria",
  "Open location in a map": "Apri posizione in una mappa",
  "Option already exists": "L'opzione esiste già",
  "Option is empty": "L'opzione è vuota",
  "Options": "Opzioni",
  "Original": "Originale",
  "People matching": "Persone che corrispondono",
  "Photo": "Foto",
  "Pin": "Appunta",
  "Pinned by {{ name }}": "Appuntato da {{ name }}",
  "Pinned by You": "Fissato da te",
  "placeholder/PollComment": "Il tuo commento",
  "placeholder/PollOptionSuggestion": "Inserisci una nuova opzione",
  "Play video": "Riproduci video",
  "Playback speed {{ rate }}x": "Velocità di riproduzione {{ rate }}x",
  "Poll": "Sondaggio",
  "Poll comments": "Commenti del sondaggio",
  "Poll ended": "Sondaggio terminato",
  "Poll options": "Opzioni del sondaggio",
  "Poll results": "Risultati del sondaggio",
  "Previous image": "Immagine precedente",
  "Question": "Domanda",
  "Question {{ optionOrderNumber}}": "Domanda {{ optionOrderNumber}}",
  "Question is required": "La domanda è obbligatoria",
  "Quote Reply": "Rispondi con citazione",
  "Reached the vote limit. Remove an existing vote first.": "Raggiunto il limite di voti. Rimuovi prima un voto esistente.",
  "Recording format is not supported and cannot be reproduced": "Il formato di registrazione non è supportato e non può essere riprodotto",
  "Remind me": "Promemoria",
  "Remind Me": "Ricordami",
  "Reminder set": "Promemoria impostato",
  "Remove reminder": "Rimuovi promemoria",
  "Remove save for later": "Rimuovi Salva per dopo",
  "Replied to a thread": "Ha risposto in un thread",
  "Reply": "Rispondi",
  "Reply to {{ authorName }}": "Rispondi a {{ authorName }}",
  "Reply to a message to start a thread": "Rispondi a un messaggio per avviare un thread",
  "Reply to Message": "Rispondi al messaggio",
  "replyCount_one": "Una risposta",
  "replyCount_many": "{{ count }} risposte",
  "replyCount_other": "{{ count }} risposte",
  "Resend": "Invia di nuovo",
  "Retry upload": "Riprova caricamento",
  "Review all options available in this poll": "Rivedi tutte le opzioni disponibili in questo sondaggio",
  "Review comments submitted with poll answers": "Rivedi i commenti inviati con le risposte al sondaggio",
  "Review poll results and open an option to see detailed votes": "Rivedi i risultati del sondaggio e apri un'opzione per vedere i voti dettagliati",
  "Review this message and choose whether to delete it, edit it, or send it anyway": "Rivedi questo messaggio e scegli se eliminarlo, modificarlo o inviarlo comunque",
  "Review who voted for this option": "Rivedi chi ha votato per questa opzione",
  "Save for later": "Salva per dopo",
  "Saved for later": "Salvato per dopo",
  "Search": "Cerca",
  "Search GIFs": "Cerca GIF",
  "search-results-header-filter-source-button-label--channels": "canali",
  "search-results-header-filter-source-button-label--messages": "messaggi",
  "search-results-header-filter-source-button-label--users": "utenti",
  "Searching for {{ searchSourceType }}...": "Ricerca di {{ searchSourceType }}...",
  "Searching...": "Ricerca in corso...",
  "searchResultsCount_one": "1 risultato",
  "searchResultsCount_many": "{{ count }} risultati",
  "searchResultsCount_other": "{{ count }} risultati",
  "Select a thread to continue the conversation": "Seleziona un thread per continuare la conversazione",
  "Select more than one option": "Seleziona più di un'opzione",
  "Select one": "Seleziona uno",
  "Select one or more": "Seleziona uno o più",
  "Select up to {{count}}_one": "Seleziona fino a {{count}}",
  "Select up to {{count}}_many": "Seleziona fino a {{count}}",
  "Select up to {{count}}_other": "Seleziona fino a {{count}}",
  "Select your current location and optionally enable live location sharing": "Seleziona la tua posizione attuale e abilita facoltativamente la condivisione della posizione in tempo reale",
  "Send": "Invia",
  "Send a message": "Invia un messaggio",
  "Send a message to start the conversation": "Invia un messaggio per iniziare la conversazione",
  "Send Anyway": "Invia comunque",
  "Send message request failed": "Richiesta di invio messaggio non riuscita",
  "Send poll": "Invia sondaggio",
  "Sending...": "Invio in corso...",
  "Sent": "Inviato",
  "Share": "Condividi",
  "Share live location for": "Condividi posizione live per",
  "Share Location": "Condividi posizione",
  "Shared live location": "Posizione live condivisa",
  "Shared location": "Posizione condivisa",
  "Shuffle": "Mescolare",
  "size limit": "limite di dimensione",
  "Slow Mode ON": "Modalità lenta attivata",
  "Slow mode, wait {{ seconds }}s...": "Modalità lenta, attendi {{ seconds }} s...",
  "Some of the files will not be accepted": "Alcuni dei file non saranno accettati",
  "Start typing to search": "Inizia a digitare per cercare",
  "Stop sharing": "Ferma condivisione",
  "Submit": "Invia",
  "Suggest a new option to add to this poll": "Suggerisci una nuova opzione da aggiungere a questo sondaggio",
  "Suggest an option": "Suggerisci un'opzione",
  "Tap to remove": "Tocca per rimuovere",
  "Tap to remove: {{ reactionName }}": "Tocca per rimuovere: {{ reactionName }}",
  "Thinking...": "Pensando...",
  "this content could not be displayed": "questo contenuto non può essere mostrato",
  "This field cannot be empty or contain only spaces": "Questo campo non può essere vuoto o contenere solo spazi",
  "This message did not meet our content guidelines": "Questo messaggio non soddisfa le nostre linee guida sui contenuti",
  "Thread": "Discussione",
  "Thread has not been found": "Discussione non trovata",
  "Thread reply": "Risposta nella discussione",
  "Thread Reply": "Risposta nella discussione",
  "ThreadListUnseenThreadsBanner/loading": "Caricamento...",
  "ThreadListUnseenThreadsBanner/unreadThreads_one": "{{ count }} thread non letto",
  "ThreadListUnseenThreadsBanner/unreadThreads_many": "{{ count }} thread non letti",
  "ThreadListUnseenThreadsBanner/unreadThreads_other": "{{ count }} thread non letti",
  "Threads": "Thread",
  "timestamp/ChannelPreviewTimestamp": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"LT\", \"lastDay\": \"[Ieri]\", \"lastWeek\": \"dddd\", \"sameElse\": \"L\" }) }}",
  "timestamp/DateSeparator": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"[Oggi]\", \"nextDay\": \"[Domani]\", \"lastDay\": \"[Ieri]\", \"nextWeek\": \"dddd\", \"lastWeek\": \"[Scorsa] dddd\", \"sameElse\": \"ddd, D MMM\" }) }}",
  "timestamp/LiveLocation": "{{ timestamp | timestampFormatter(calendar: true) }}",
  "timestamp/MessageTimestamp": "{{ timestamp | timestampFormatter(calendar: false; format: HH:mm) }}",
  "timestamp/PollVote": "{{ timestamp | timestampFormatter(relativeCompact: true) }}",
  "timestamp/PollVoteTooltip": "{{ timestamp | timestampFormatter(calendar: true) }}",
  "timestamp/relativeDaysAgo": "{{ count }}d ago",
  "timestamp/relativeToday": "Oggi",
  "timestamp/relativeWeeksAgo": "{{ count }}w ago",
  "timestamp/relativeYesterday": "Ieri",
  "timestamp/ReminderNotification": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"[Today] [at] HH:mm\", \"nextDay\": \"[Tomorrow] [at] HH:mm\", \"lastDay\": \"[Yesterday] [at] HH:mm\", \"nextWeek\": \"dddd [at] HH:mm\", \"lastWeek\": \"[Last] dddd [at] HH:mm\", \"sameElse\": \"ddd, D MMM [at] HH:mm\" }) }}",
  "timestamp/SystemMessage": "{{ timestamp | timestampFormatter(format: dddd L) }}",
  "To start recording, allow the camera access in your browser": "Per iniziare a registrare, consenti l'accesso alla fotocamera nel tuo browser",
  "To start recording, allow the microphone access in your browser": "Per iniziare a registrare, consenti l'accesso al microfono nel tuo browser",
  "totalVoteCount_one": "1 voto in totale",
  "totalVoteCount_many": "{{ count }} voti in totale",
  "totalVoteCount_other": "{{ count }} voti in totale",
  "Translated": "Tradotto",
  "Translated from {{ language }}": "Tradotto da {{ language }}",
  "translationBuilderTopic/notification": "{{value, notification}}",
  "Type a number from 2 to 10": "Digita un numero da 2 a 10",
  "Unarchive": "Ripristina",
  "unban-command-args": "[@nomeutente]",
  "unban-command-description": "Togliere il divieto a un utente",
  "Unblock User": "Sblocca utente",
  "unknown error": "errore sconosciuto",
  "Unmute": "Riattiva il notifiche",
  "unmute-command-args": "[@nomeutente]",
  "unmute-command-description": "Togliere il silenzio a un utente",
  "Unpin": "Sblocca",
  "Unread messages": "Messaggi non letti",
  "Unsupported attachment": "Allegato non supportato",
  "unsupported file type": "tipo di file non supportato",
  "Update": "Aggiorna",
  "Update the comment attached to your poll answer": "Aggiorna il commento allegato alla tua risposta al sondaggio",
  "Update your comment": "Aggiorna il tuo commento",
  "Upload blocked": "Caricamento bloccato",
  "Upload error": "Errore di caricamento",
  "Upload failed": "Caricamento non riuscito",
  "Upload type: \"{{ type }}\" is not allowed": "Tipo di caricamento: \"{{ type }}\" non è consentito",
  "User blocked": "Utente bloccato",
  "User unblocked": "Utente sbloccato",
  "User uploaded content": "Contenuto caricato dall'utente",
  "Video": "Video",
  "videoCount_one": "Video",
  "videoCount_many": "{{ count }} video",
  "videoCount_other": "{{ count }} video",
  "View": "Visualizza",
  "View {{count}} comments_one": "Visualizza {{count}} commento",
  "View {{count}} comments_many": "Visualizza {{count}} commenti",
  "View {{count}} comments_other": "Visualizza {{count}} commenti",
  "View all": "Visualizza tutto",
  "View original": "Visualizza originale",
  "View results": "Vedi risultati",
  "View translation": "Visualizza traduzione",
  "Voice message": "Messaggio vocale",
  "Voice message {{ duration }}": "Messaggio vocale {{ duration }}",
  "Voice message deleted": "Messaggio vocale eliminato",
  "voiceMessageCount_one": "Messaggio vocale",
  "voiceMessageCount_many": "{{ count }} messaggi vocali",
  "voiceMessageCount_other": "{{ count }} messaggi vocali",
  "Vote ended": "Voto terminato",
  "Votes": "Voti",
  "Wait until all attachments have uploaded": "Attendi il caricamento di tutti gli allegati",
  "Waiting for network…": "In attesa della rete…",
  "You": "Tu",
  "You've reached the maximum number of files": "Hai raggiunto il numero massimo di file"
}
